const styles = (theme) => ({
  error: {
    marginBottom: theme.spacing(2),
    fontSize: theme.typography.pxToRem(12),
  },
  reset: {
    marginTop: theme.spacing(2),
  },
});

export default styles;
